import { Callout, Intent, Switch } from '@blueprintjs/core';
import { Target } from '@retro-ui/api-contract';
import { css, styled } from '@stitches/react';
import { Dispatch, SetStateAction, useMemo } from 'react';

import { TargetValidation } from '../hooks/useTargetValidation';

const SummaryContainer = styled('div', {
  marginTop: '1rem',
});

const SummaryBody = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});

const invalidTargetsSwitchStyle = css({
  'margin': '0 !important',
  '& input:checked ~ .bp4-control-indicator': {
    backgroundColor: '$amber8 !important',
  },
});

interface TargetValidationCalloutProps {
  targets: Target[] | null;
  targetValidation: TargetValidation;
  filterInvalidSmiles: boolean;
  onFilterInvalidSmilesChange: Dispatch<SetStateAction<boolean>>;
}
export function TargetValidationCallout(props: TargetValidationCalloutProps) {
  const { targets, targetValidation, filterInvalidSmiles, onFilterInvalidSmilesChange } = props;
  const { generalError, smilesErrors } = targetValidation;

  const error = useMemo(() => {
    if (!targets) {
      return null;
    }

    if (generalError) {
      return {
        intent: Intent.DANGER,
        message: generalError,
      };
    }

    if (smilesErrors.length > 0) {
      return {
        intent: Intent.WARNING,
        message: (
          <>
            {smilesErrors.length} out of {targets.length} target SMILES could not be parsed.
            <br />
            All targets including the failing ones will be included in the results.
          </>
        ),
      };
    }

    return null;
  }, [targets, generalError, smilesErrors]);

  if (error === null) {
    return null;
  }

  return (
    <SummaryContainer>
      <Callout intent={error.intent}>
        <SummaryBody>
          <span>{error.message}</span>
          {error.intent === Intent.WARNING && (
            <Switch
              className={invalidTargetsSwitchStyle()}
              checked={filterInvalidSmiles}
              label="Show only invalid targets"
              onChange={() => {
                onFilterInvalidSmilesChange(!filterInvalidSmiles);
              }}
            />
          )}
        </SummaryBody>
      </Callout>
    </SummaryContainer>
  );
}
